import * as z from "zod";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

export const deletePersonalChat = mutator({
  schema: z.object({ id: z.string() }),
  resolve: {},
  permissions: {
    none: "personal chats are read and written only for ctx.userId",
  },
  description: "Deletes a personal chat from the user’s chat history.",
  interactionType: "delete",
  fn: async ({ tx, ctx, args }) => {
    const chat = await tx.run(
      zql.personalChats
        .where("id", args.id)
        .where("userId", ctx.userId)
        .where("tenantId", ctx.tenantId)
        .where("deletedAt", "IS", null)
        .one()
    );
    if (!chat) return;
    await tx.mutate.personalChats.update({
      id: chat.id,
      deletedAt: Date.now(),
    });
  },
});
